import DesktopFooter from './DesktopFooter';

export default DesktopFooter;
